import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { getLanguage } from '@citrite/translate';
import { withTheme } from '@emotion/react';
import { Button } from '../../Button';
import { fromThemeColors } from '../../Theme';
import { withTranslate } from '../../util';
import { StyledCalendar, StyledCalendarHeader, StyledLeftChevronIcon, StyledLeftDoubleChevronIcon, StyledMonthJumper, StyledMonthName, StyledRightChevronIcon, StyledRightDoubleChevronIcon } from './Calendar.styled';
import { addDays, getDaysInMonth, getFirstWeekOffset, getMonthOffset } from './dateUtils';
import { Month } from './Month';
var _Calendar = /*#__PURE__*/function (_React$Component) {
  function _Calendar() {
    var _this;
    _classCallCheck(this, _Calendar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _Calendar, [].concat(args));
    _defineProperty(_this, "state", {
      monthOffset: getMonthOffset(_this.props.date || _this.props.dateRange || new Date(Date.now()))
    });
    _defineProperty(_this, "onMonthFocus", function () {
      _this.setState({
        arrowKeyNav: true
      });
    });
    _defineProperty(_this, "onMonthBlur", function () {
      _this.setState({
        arrowKeyNav: false
      });
    });
    _defineProperty(_this, "setMonthOffset", function (e, diff) {
      e.stopPropagation();
      var monthOffset = _this.state.monthOffset + diff;
      if (diff < 0 && !_this.canDecreaseMonth(monthOffset)) {
        monthOffset = getMonthOffset(_this.props.minDate);
      } else if (diff > 0 && !_this.canIncreaseMonth(monthOffset)) {
        monthOffset = getMonthOffset(_this.props.maxDate);
      }
      _this.setState({
        monthOffset: monthOffset
      });
      _this.props.onFocusChange(null);
    });
    _defineProperty(_this, "onKeyDown", function (e) {
      if (!_this.state.arrowKeyNav) {
        return;
      }
      var diff = 0;
      switch (e.key) {
        case 'ArrowRight':
          diff = 1;
          break;
        case 'ArrowLeft':
          diff = -1;
          break;
        case 'ArrowDown':
          diff = 7;
          break;
        case 'ArrowUp':
          diff = -7;
          break;
      }
      if (diff === 0) {
        return;
      }
      e.preventDefault();
      _this.props.onFocusChange(addDays(_this.props.focusedDate, diff));
    });
    return _this;
  }
  _inherits(_Calendar, _React$Component);
  return _createClass(_Calendar, [{
    key: "visibleMonth",
    get: function get() {
      var visibleDate = new Date(Date.now());
      visibleDate.setDate(1);
      visibleDate.setMonth(visibleDate.getMonth() + this.state.monthOffset);
      return visibleDate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var actionIconColor = fromThemeColors('secondaryActionIcon')(this.props);
      return /*#__PURE__*/React.createElement(StyledCalendar, null, /*#__PURE__*/React.createElement(StyledCalendarHeader, null, /*#__PURE__*/React.createElement(StyledMonthJumper, null, /*#__PURE__*/React.createElement(Button.Wrapper, {
        onClick: function onClick(e) {
          return _this2.setMonthOffset(e, -12);
        },
        disabled: !this.canDecreaseMonth(this.state.monthOffset),
        "aria-label": t('citrix-ui:date.jump_back_year')
      }, /*#__PURE__*/React.createElement(StyledLeftDoubleChevronIcon, {
        size: 14,
        color: actionIconColor
      })), /*#__PURE__*/React.createElement(Button.Wrapper, {
        onClick: function onClick(e) {
          return _this2.setMonthOffset(e, -1);
        },
        disabled: !this.canDecreaseMonth(this.state.monthOffset),
        "aria-label": t('citrix-ui:date.jump_back_month')
      }, /*#__PURE__*/React.createElement(StyledLeftChevronIcon, {
        size: 14,
        color: actionIconColor
      }))), /*#__PURE__*/React.createElement(StyledMonthName, null, this.visibleMonth.toLocaleString(getLanguage(), {
        month: 'long',
        year: 'numeric'
      })), /*#__PURE__*/React.createElement(StyledMonthJumper, null, /*#__PURE__*/React.createElement(Button.Wrapper, {
        onClick: function onClick(e) {
          return _this2.setMonthOffset(e, 1);
        },
        disabled: !this.canIncreaseMonth(this.state.monthOffset),
        "aria-label": t('citrix-ui:date.jump_forward_month')
      }, /*#__PURE__*/React.createElement(StyledRightChevronIcon, {
        size: 14,
        color: actionIconColor
      })), /*#__PURE__*/React.createElement(Button.Wrapper, {
        onClick: function onClick(e) {
          return _this2.setMonthOffset(e, 12);
        },
        disabled: !this.canIncreaseMonth(this.state.monthOffset),
        "aria-label": t('citrix-ui:date.jump_forward_year')
      }, /*#__PURE__*/React.createElement(StyledRightDoubleChevronIcon, {
        size: 14,
        color: actionIconColor
      })))), /*#__PURE__*/React.createElement("div", {
        onFocus: this.onMonthFocus,
        onBlur: this.onMonthBlur
      }, /*#__PURE__*/React.createElement(Month, {
        weeks: this.getWeeks(this.visibleMonth),
        onDateClick: this.props.onChange,
        onFocusChange: this.props.onFocusChange
      })));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.didDateChange(prevProps.date, this.props.date)) {
        this.setState(function (_, props) {
          return {
            monthOffset: getMonthOffset(props.date)
          };
        });
        return;
      }
      if (this.didDateChange(prevProps.focusedDate, this.props.focusedDate)) {
        this.setState(function (_, props) {
          return {
            monthOffset: getMonthOffset(props.focusedDate)
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "didDateChange",
    value: function didDateChange(prevDate, newDate) {
      if (!newDate) {
        return false;
      }
      return !prevDate || prevDate.getMonth() !== newDate.getMonth() || prevDate.getDate() !== newDate.getDate();
    }
  }, {
    key: "getWeeks",
    value: function getWeeks(month) {
      var weeksToShow = 6;
      var daysInWeek = 7;
      var days = this.getVisibleDays(month);
      var weeks = [];
      for (var i = 0; i < weeksToShow; i++) {
        weeks[i] = [];
        for (var j = 0; j < daysInWeek; j++) {
          weeks[i].push(days[i * daysInWeek + j]);
        }
      }
      return weeks;
    }

    /** Returns all days of the month plus front and back filled days from the previous and next month */
  }, {
    key: "getVisibleDays",
    value: function getVisibleDays(month) {
      var dayProps = {
        selectedDate: this.props.date,
        focusedDate: this.props.focusedDate,
        dateRange: this.props.dateRange || null,
        minDate: this.props.minDate,
        maxDate: this.props.maxDate,
        excludedDates: this.props.excludedDates
      };

      // get days in the visible month
      var calendar = getDaysInMonth(_objectSpread({
        month: month,
        inCurrentMonth: true
      }, dayProps));

      // get days from previous month to backfill calendar
      var previousMonth = new Date(month);
      previousMonth.setMonth(month.getMonth() - 1);
      var daysInPreviousMonth = getDaysInMonth(_objectSpread({
        month: previousMonth,
        inCurrentMonth: false
      }, dayProps));
      daysInPreviousMonth = daysInPreviousMonth.slice(daysInPreviousMonth.length - getFirstWeekOffset(month), daysInPreviousMonth.length);
      calendar.unshift.apply(calendar, _toConsumableArray(daysInPreviousMonth));

      // get days from next month to fill end of calendar
      var nextMonth = new Date(month);
      nextMonth.setMonth(month.getMonth() + 1);
      var daysInNextMonth = getDaysInMonth(_objectSpread({
        month: nextMonth,
        inCurrentMonth: false
      }, dayProps));
      calendar.push.apply(calendar, _toConsumableArray(daysInNextMonth));
      return calendar;
    }
  }, {
    key: "canDecreaseMonth",
    value: function canDecreaseMonth(monthOffset) {
      return !this.props.minDate || getMonthOffset(this.props.minDate) < monthOffset;
    }
  }, {
    key: "canIncreaseMonth",
    value: function canIncreaseMonth(monthOffset) {
      return !this.props.maxDate || getMonthOffset(this.props.maxDate) > monthOffset;
    }
  }]);
}(React.Component);
export var Calendar = withTheme(withTranslate(_Calendar));